import ViewPurchaseOrder from "../../../../components/@documents/purchase_orders/ViewPurchaseOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseOrderViewPage() {

    return (
        <ViewPurchaseOrder 
            routeType={routeTypes.retail}
        />
    )
}